/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgStoppedRunning56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path fill='currentColor' d='M24.063 26.563h-7v-1.5h7v1.5z' />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M1 28C1 13.088 13.088 1 28 1s27 12.088 27 27-12.088 27-27 27S1 42.912 1 28zM28 2.5C13.917 2.5 2.5 13.917 2.5 28c0 6.772 2.64 12.927 6.946 17.493l4.368-4.368-2.752-2.752v-9.185h-3.75v5.375h-1.5v-12.25h1.5v5.375h3.75v-9.625h3.85l3.5-5.25h13.052l3.5 5.25h1.913l8.616-8.617A25.412 25.412 0 0028 2.5zm18.554 8.007l-7.742 7.741v5.064h3.75v-.75a2.75 2.75 0 012.75-2.75h4v17.25h-4a2.75 2.75 0 01-2.75-2.75v-.75h-3.75v4.811l-5.689 5.69H16.752l-1.877-1.877-4.368 4.368A25.412 25.412 0 0028 53.5c14.083 0 25.5-11.417 25.5-25.5 0-6.772-2.64-12.927-6.946-17.493zM15.936 41.125l1.437 1.438h15.129l3.75-3.75H18.248l-2.312 2.312zm3.812-3.813h17.564V19.748L26.748 30.312h4.314v1.5h-5.814l-5.5 5.5zm3.379-5.5l-5.5 5.5h-5.064v-17.75h22.814l-10.75 10.75h-7.564v1.5h6.064zm-7 7l-1.252 1.252-1.252-1.252h2.504zm17.034-20.75l-2.5-3.75H19.214l-2.5 3.75H33.16zm5.651 6.75h3.75v7.25h-3.75v-7.25zm6.5-3.5c-.69 0-1.25.56-1.25 1.25v11.75c0 .69.56 1.25 1.25 1.25h2.5v-14.25h-2.5z'
      />
    </svg>
  );
}

export default SvgStoppedRunning56;
